import { NgModule } from '@angular/core';
import { IonicApp, IonicModule } from 'ionic-angular';
import { MyApp } from './app.component';

// Components 
import { HomePage }             from '../pages/home/home.component';
import { LoginPage }            from '../pages/login/login.component';
import { SettingsPage }         from '../pages/settings/settings.component';
import { CreateReportPage }     from '../pages/create-report/create-report.component';
import { ContinueReportPage }   from '../pages/continue-report/continue-report.component';
import { ReportPage }           from '../pages/report/report.component';
import { MainReportTab }        from '../pages/report/tab-main/tab-main.component';
import { InfoReportTab }        from '../pages/report/tab-info/tab-info.component';
import { WeatherReportTab }     from '../pages/report/tab-weather/tab-weather.component';
import { ActivityPage }         from '../pages/report/tab-main/activity/activity.component';
import { ActivityModal }        from '../pages/report/tab-main/activity/activity-modal/activity-modal.component';
import { ActivityPopover }      from '../pages/report/tab-main/activity/activity-popover/activity-popover.component';
import { LaborPage }            from '../pages/report/tab-main/labor/labor.component';
import { LaborModal }           from '../pages/report/tab-main/labor/labor-modal/labor-modal.component';
import { LaborPopover }         from '../pages/report/tab-main/labor/labor-popover/labor-popover.component';
import { SubcontractorPage }    from '../pages/report/tab-main/subcontractor/subcontractor.component';
import { SubcontractorModal }   from '../pages/report/tab-main/subcontractor/subcontractor-modal/subcontractor-modal.component';
import { SubcontractorPopover } from '../pages/report/tab-main/subcontractor/subcontractor-popover/subcontractor-popover.component';
import { PicturePage }          from '../pages/report/tab-main/picture/picture.component';
import { PictureModal }         from '../pages/report/tab-main/picture/picture-modal/picture-modal.component';
import { EquipmentPage }        from '../pages/report/tab-main/equipment/equipment.component';
import { EquipmentModal }       from '../pages/report/tab-main/equipment/equipment-modal/equipment-modal.component';
import { EquipmentPopover }     from '../pages/report/tab-main/equipment/equipment-popover/equipment-popover.component';
import { InspectionPage }       from '../pages/report/tab-main/inspection/inspection.component';
import { InspectionModal }      from '../pages/report/tab-main/inspection/inspection-modal/inspection-modal.component';
import { InspectionPopover }    from '../pages/report/tab-main/inspection/inspection-popover/inspection-popover.component';
import { JurisdictionPopover }  from '../pages/report/tab-main/inspection/inspection-popover/jurisdiction-popover.component';
import { OrderPage }            from '../pages/report/tab-main/order/order.component';
import { NotesPage }            from '../pages/report/tab-main/notes/notes.component';
import { SchedulePage }         from '../pages/report/tab-main/schedule/schedule.component';
import { MileagePage }          from '../pages/mileage/mileage.component';

// Pipes 
import { WorkHoursPipe }        from '../pipes/workhours.pipe';
import { MonthPipe }            from '../pipes/month.pipe';

// Global Providers
import {rsSessionSvc}           from '../services/auth.service';
import {rsReportSvc}            from '../services/report.service';
import {rsProjectSvc}           from '../services/project.service';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    LoginPage,
    SettingsPage,
    CreateReportPage,
    ContinueReportPage,
    ReportPage,
    MainReportTab,
    InfoReportTab,
    WeatherReportTab,
    ActivityPage,
    ActivityModal,
    ActivityPopover,
    LaborPage,
    LaborModal,
    LaborPopover,
    WorkHoursPipe,
    MonthPipe,
    SubcontractorPage,
    SubcontractorModal,
    SubcontractorPopover,
    PicturePage,
    PictureModal,
    EquipmentPage,
    EquipmentModal,
    EquipmentPopover,
    InspectionPage,
    InspectionModal,
    InspectionPopover,
    JurisdictionPopover,
    OrderPage,
    NotesPage,
    SchedulePage,
    MileagePage
  ],
  imports: [
    IonicModule.forRoot(MyApp),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    LoginPage,
    SettingsPage,
    CreateReportPage,
    ContinueReportPage,
    ReportPage,
    MainReportTab,
    InfoReportTab,
    WeatherReportTab,
    ActivityPage,
    ActivityModal,
    ActivityPopover,
    LaborPage,
    LaborModal,
    LaborPopover,
    SubcontractorPage,
    SubcontractorModal,
    SubcontractorPopover,
    PicturePage,
    PictureModal,
    EquipmentPage,
    EquipmentModal,
    EquipmentPopover,
    InspectionPage,
    InspectionModal,
    InspectionPopover,
    JurisdictionPopover,
    OrderPage,
    NotesPage,
    SchedulePage,
    MileagePage
  ],
  providers: [
    rsSessionSvc,
    rsReportSvc,
    rsProjectSvc
  ]
})
export class AppModule {}




// WEBPACK FOOTER //
// ./src/app/app.module.ts